import { property, supertypeClass } from '@haventech/amorphic';
import { IsomorphicPersistent } from '@hit/amorphic-types';
import { Person } from '../../../common/js/customer/Person';
import {
  AnnuityRefundType,
  AnnuityFrequency,
  AnnuityInflationProtector,
  AnnuityLives,
  AnnuitySurvivorshipOption,
  AnnuityReductionAmounts,
  AnnuityGuaranteePeriod,
  AnnuityMarket,
  AnnuityPeriodCertainOnlyLives,
  AnnuityRenewalOption,
  AnnuityWithdrawalType,
} from '../../js/interfaces/CoverpathTypes';
import { AnnuitySourcePayment } from './AnnuitySourcePayment';
@supertypeClass({ toClient: true, toServer: false })
export class AnnuityAttributes extends IsomorphicPersistent {
  static new(): AnnuityAttributes {
    return new AnnuityAttributes().init();
  }

  init() {
    return this;
  }

  constructor() {
    super();
  }

  @property({
    comment: 'Amount submitted with application',
  })
  initialPurchaseAmount: number;

  @property({
    comment: 'The annuitant',
  })
  annuitant: Person;

  @property({
    comment: 'The joint annuitant (if any)',
  })
  jointAnnuitant: Person;

  @property({
    comment: 'The distributing frequency, value must be one of : Monthly, Quarterly, Semi-Annual, Annual',
  })
  distributingFrequency: AnnuityFrequency;

  @property({
    comment: 'The refund type',
  })
  refundType: AnnuityRefundType;

  @property({
    comment: 'Lives',
  })
  lives: AnnuityLives;

  @property({
    comment: 'The start date of the annuity',
  })
  annuitizationDate: Date;

  @property({
    comment: 'The recurring purchase frequency, value must be one of : Monthly, Quarterly, Semi-Annual, Annual',
  })
  recurringPurchaseFrequency: AnnuityFrequency;

  @property({
    comment: 'The recurring purchase amount',
  })
  recurringPurchaseAmount: number;

  @property({
    comment: 'The initial payout amount',
  })
  initialPayoutAmount: number;

  @property({
    comment: 'Return of premium',
  })
  returnOfPremium: boolean;

  @property({
    comment: 'Inflation Protector Rider',
  })
  inflationProtectionRider: AnnuityInflationProtector;

  @property({
    comment: 'Quote Effective Date (i.e., Original Quote Date)',
  })
  quoteEffectiveDate: Date;

  @property({
    comment: 'Period certain number of years',
  })
  periodCertainNumYears: number;

  @property({
    comment: 'Period certain number of months',
  })
  periodCertainNumMonths: number;

  @property({
    comment: 'survivorship options',
  })
  survivorshipOption: AnnuitySurvivorshipOption;

  @property({
    comment: 'Reduction amount',
  })
  reductionAmount: AnnuityReductionAmounts;

  @property({
    comment: 'hold funds',
  })
  holdFunds: boolean;

  @property({
    comment: 'Guarantee Period',
  })
  guaranteePeriod: AnnuityGuaranteePeriod;

  @property({
    comment: 'Annuity Market Type',
  })
  marketType: AnnuityMarket;

  @property({
    comment: 'Annuity Source Payments',
    getType: () => AnnuitySourcePayment,
  })
  sourcePayments: Array<AnnuitySourcePayment>;

  @property({
    comment: 'Period Certain Only Lives',
  })
  periodCertainOnlyLives: AnnuityPeriodCertainOnlyLives;

  @property({
    comment: 'Renewal Option',
  })
  renewalOption: AnnuityRenewalOption;

  @property({
    comment: 'Renewal Duration',
  })
  renewalDurationInYears: number;

  @property({
    comment: 'Withdrawal Mode',
  })
  withdrawalMode: AnnuityFrequency;

  @property({
    comment: 'Withdrawal Type',
  })
  withdrawalType: AnnuityWithdrawalType;

  @property({
    comment: 'Withdrawal Value',
  })
  withdrawalValue: number;

  @property({
    comment: 'Withdrawal Start',
  })
  withdrawalStart: Date;

  @property({
    comment: 'Withdrawal End',
  })
  withdrawalEnd: Date;
}
